<script>
import FormModal from "@/components/form-modal.vue";
import MasterDetail from "@/components/master-detail.vue";
import PerfilModal from "./components/perfil-modal.vue";
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";

export default {
  components: { FormModal, MasterDetail, PerfilModal },
  data() {
    return {
      createModal: {
        data: {},
        opened: false
      },
      updateModal: {
        data: {},
        opened: false
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    actionBarButtons() {
      return [
        {
          text: "Adicionar perfil",
          icon: "mdi-plus-box-outline",
          action: () => {
            this.createModal.data = {};
            this.createModal.opened = true;
          }
        }
      ];
    },
    cols() {
      return [
        {
          key: "senioridade",
          name: "Senioridade",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }],
          colSize: 6
        },
        {
          key: "especialidade",
          name: "Especialidade",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }],
          colSize: 6
        },
        {
          key: "valor",
          name: "Custo médio",
          type: this.$fieldTypes.MONEY,
          colSize: 6
        }
      ];
    },
    contextOptions() {
      return [
        {
          name: "Editar",
          cb: row => {
            this.updateModal.data = cloneDeep(row);
            this.updateModal.opened = true;
          }
        }
      ];
    },
    customResource() {
      const resource = this.apiResource(
        `v1/ativacaoped/${this.clientId}/perfil`
      );

      return {
        ...resource,
        async get(...args) {
          try {
            const response = await resource.get(...args);

            if (!Array.isArray(response.data)) {
              return response;
            }

            return {
              ...response,
              data: response.data.map(({ custo_medio, ...rest }) => ({
                ...rest,
                custo_medio,
                valor: custo_medio?.valor ?? "Indefinido"
              }))
            };
          } catch (error) {
            return Promise.reject(error);
          }
        }
      };
    },
    formTitle() {
      const isEdit = !!this.selectedItem?.id;
      return `${isEdit ? "Edição" : "Cadastro"} de Perfil`;
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
      }
    }
  },
  methods: {
    async doCreate(data, close) {
      try {
        const { senioridade, especialidade, valor } = data;
        const body = {
          senioridade,
          especialidade,
          custos_medios: valor > 0 ? [{ valor }] : undefined
        };

        await this.customResource.save(body);
        this.doReload();

        if (close) {
          close();
        }
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    doReload() {
      this.$refs.table?.doLoad();
    },
    goToHome() {
      this.notify({
        error:
          "Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada."
      });
      this.$router.push({ name: "homepage" });
    }
  }
};
</script>

<template>
  <div>
    <MasterDetail
      ref="table"
      :actionBarButtons="actionBarButtons"
      :canDelete="false"
      :canEdit="false"
      :cols="cols"
      :contextOptions="contextOptions"
      :customResource="customResource"
      :hasFilter="false"
      :hasExportCSV="false"
      :formTitle="formTitle"
      :hasNewButton="false"
      serverPagination
      @onOpenFormDialog="selectedItem = $event"
    ></MasterDetail>

    <FormModal
      :cols="cols"
      :opened.sync="createModal.opened"
      title="Cadastro de Perfil"
      :value.sync="createModal.data"
      @save="doCreate"
    />

    <PerfilModal
      :opened.sync="updateModal.opened"
      :value.sync="updateModal.data"
      @saved="doReload"
    />
  </div>
</template>
